export default async function (message_id, token) {
  return await fetch(
    `${process.env.VUE_APP_API_URL}/voter/messages/${message_id}`,
    {
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
}
